export default class Toastr {
	constructor() {
		this.init();
	}

	init() {
		const flashMessagesInput = document.querySelector('input[type="hidden"][name="flashMessages"]');
		const flashMessages = flashMessagesInput.value;
		const dontHideAll = flashMessagesInput.getAttribute('data-fm-dont-hide-all') === '1';
		const dontHide = JSON.parse(flashMessagesInput.getAttribute('data-fm-dont-hide'));
		const dontDismissAll = flashMessagesInput.getAttribute('data-fm-dont-dismiss-all') === '1';
		const dontDismiss = JSON.parse(flashMessagesInput.getAttribute('data-fm-dont-dismiss'));
		let parent = this;

		flashMessagesInput.value = [];

		if (flashMessages) {
			Array.prototype.forEach.call(JSON.parse(flashMessages), async function (flashMessage, key) {
				parent.showFlashMessage(
					flashMessage['message'],
					flashMessage['type'],
					dontHideAll === true || dontHide.includes(flashMessage['type']),
					dontDismissAll === true || dontDismiss.includes(flashMessage['type'])
				);

				await sleep(100);
			});
		}

		global.showFlashMessage = (message, type, dontHide = false, dontDismissFM = false) => {
			this.showFlashMessage(
				message,
				type,
				dontHide,
				dontDismissFM
			);
		}
	}

	showFlashMessage(message, type, dontHide, dontDismissFM) {
		this.setToastrDefaultConfig();

		if (dontHide || type === 'critical') {
			window.toastr.options.timeOut = 0;
			window.toastr.options.extendedTimeOut = 0;
		} else {
			window.toastr.options.timeOut = type === 'success' ? 3500 : 5000;
			window.toastr.options.extendedTimeOut = 1000;
		}

		if (dontDismissFM || type === 'critical') {
			window.toastr.options.tapToDismiss = false;
		}

		switch (type) {
			case 'error':
			case 'critical':
			case 'danger':
				window.toastr.error(message);
				break;
			case 'success':
				window.toastr.success(message);
				break;
			case 'warning':
				window.toastr.warning(message);
				break;
			default:
				window.toastr.info(message);
		}

		if (document.getElementById('toastr-container')) {
			let top = 12;
			let menu = document.getElementById('kt_app_header');
			let toolbar = document.getElementById('kt_app_toolbar');

			if (menu) {
				top += menu.getBoundingClientRect().height;
			}

			if (toolbar) {
				top += toolbar.getBoundingClientRect().height;
			}

			document.getElementById('toastr-container').style.top = top + "px";
		}
	}

	setToastrDefaultConfig() {
		window.toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": true,
			"positionClass": "toast-top-right",
			"preventDuplicates": true,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		};
	}
}
